/* eslint-disable camelcase */
// eslint-disable-next-line no-unused-vars
import React, { useContext, useEffect, useMemo } from 'react';
import { gql, useQuery, useReactiveVar } from '@apollo/client';
import { abTestDataContext, CASHBACK_NEW_USERS_V2, CASHBACK_NEW_USERS } from 'app/containers/contexts/abTest.context';
import { isAsNewbieAuthedVar } from 'app/apollo/reaction';

// unfetched

export const useCashbackNewUsersABTest = (
    selfExecutable: boolean = true,
) => {
    const {
        // @ts-ignore
        cashback_new_users_v2,
        // @ts-ignore
        fetchABTestValue,
        // @ts-ignore
        setABTestValue,
    } = useContext(abTestDataContext);
    // const isAsNewbieAuthed = useReactiveVar(isAsNewbieAuthedVar);

    const BAKSET_GOOD_DELIVERIES_USER_QUERY = gql`
    query BAKSET_GOOD_DELIVERIES_USER_QUERY {
            user {
                id
                hasGoodDeliveries
                ab_groups
            }
        }
    `;

    const { data: { user } } = useQuery(BAKSET_GOOD_DELIVERIES_USER_QUERY, {
        fetchPolicy: 'cache-first',
    });

    const isUserInABTestAlready = useMemo(
        () => user?.ab_groups?.some((group: string) => group.includes(CASHBACK_NEW_USERS) || group.includes(CASHBACK_NEW_USERS_V2)),
        [user?.ab_groups],
    );

    const previousTestValue = useMemo(
        () => {
            if (isUserInABTestAlready) {
                const targetGroup = user?.ab_groups?.find((group: string) => group.includes(CASHBACK_NEW_USERS));
                const targetGroupValue = targetGroup.split('__')[1];
                return targetGroupValue;
            }
            return undefined;
        },
        [user?.ab_groups, isUserInABTestAlready],
    );

    // const isNeedToFetchABTest = useMemo(
    //     () => (
    //         ((user && !user?.hasGoodDeliveries && !isUserInABTestAlready)
    //             || isAsNewbieAuthed
    //         )
    //         && cashback_new_users_v2 === 'unfetched'
    //     ),
    //     [
    //         user,
    //         isAsNewbieAuthed,
    //         isUserInABTestAlready,
    //         cashback_new_users_v2,
    //     ],
    // );

    // console.log(isUserInABTestAlready, 'isUserInABTestAlready');
    // console.log(user?.ab_groups, 'user ab groups');
    // console.log(isNeedToFetchABTest, 'isNeedToFetchABTest');
    // console.log(isAsNewbieAuthed, 'isAsNewbieAuthed');
    // console.log(cashback_new_users_v2, 'cashback_new_users_v2');
    // console.log(previousTestValue, 'previousTestValue');

    // useEffect(
    //     () => {
    //         if (isNeedToFetchABTest && selfExecutable) {
    //             fetchABTestValue('cashback_new_users_v2');
    //         }
    //         // eslint-disable-next-line react-hooks/exhaustive-deps
    //     }, [user?.id, selfExecutable],
    // );

    useEffect(
        () => {
            if (isUserInABTestAlready) {
                setABTestValue(CASHBACK_NEW_USERS, previousTestValue);
            }
        },
        [isUserInABTestAlready, setABTestValue, previousTestValue],
    );

    return [
        previousTestValue ?? cashback_new_users_v2,
        () => fetchABTestValue('cashback_new_users_v2'),
    ];
};
